export default {
    eta_destination: "Destination",
    eta_start: "Start",
    eta_end: "End",
    eta_copyLink: "Copy Link",
    eta_copied: "Copied"
}